import React, { Component } from "react";
import { Modal, Button, Row } from "react-bootstrap";
import { connect } from "react-redux";
import TextField from "../fields/TextField";
import DateField from "../fields/DateField";
import SelectField from "../fields/SelectField";
import BooleanField from "../fields/BooleanField";
import { buildOptions } from "../utils";

class DemographicsFormModal extends Component {
  handleClose() {
    this.props.closeModal();
  }

  render() {
    const genderOptions = buildOptions([
      "Male",
      "Female",
      "Trans",
      "Non-Binary",
    ]);
    const maritalStatusOptions = buildOptions([
      "Single",
      "Married",
      "Divorced",
      "Separated",
      "Widowed",
    ]);
    const raceOptions = buildOptions([
      "American Indian or Alaska Native ",
      "Indian",
      "Asian",
      "Black or African American",
      "White",
      "Hispanic",
      "Hawaiian or Other Pacific Islander",
    ]);
    const ethnicityOptions = buildOptions([
      "Hispanic or Latino or Spanish Origin",
      "Not Hispanic or Latino or Spanish Origin",
    ]);
    const veteranStatusOptions = buildOptions([
      "Yes",
      "No",
      "Disabled veteran",
      "Recently separated veteran",
      "Active Duty Wartime or Campaign Badge Veteran",
      "Armed Forces Service Medal Veteran"
    ]);

    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>Demographics</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <SelectField
              name="gender"
              label="Gender"
              options={genderOptions}
              creatable
              action="edit"
              col={6}
            />
            <TextField name="school" label="School" action="edit" col={6} />
            <SelectField
              name="marital_status"
              label="Marital Status"
              options={maritalStatusOptions}
              action="edit"
              col={6}
            />
            <SelectField
              name="race"
              label="Race"
              options={raceOptions}
              creatable
              action="edit"
              col={6}
            />
            <SelectField
              name="ethnicity"
              label="Ethnicity"
              options={ethnicityOptions}
              creatable
              action="edit"
              col={6}
            />
            <SelectField
              name="veteran_status"
              label="Veteran"
              options={veteranStatusOptions}
              creatable
              action="edit"
              col={6}
            />
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="info" onClick={() => this.props.closeModal()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.demographicsModal.show,
    hasDelete: state.current_user.permissions.includes("Delete"),
    hasEdit: state.current_user.permissions.includes("Edit"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () =>
      dispatch({
        type: "CLOSE_RESOURCE_MODAL",
        payload: { resourceName: "demographics" },
      }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DemographicsFormModal);
